import { Box, Paper } from "@mui/material";
import PropTypes from "prop-types";

const FiltersWrapper = ({ children }) => {
    return (
        <Paper elevation={3} sx={{ p: 2, mb: 2 }}>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    alignItems: "center",
                    gap: 2,
                }}
            >
                {children}
            </Box>
        </Paper>
    );
};

FiltersWrapper.propTypes = {
    children: PropTypes.node.isRequired,
};

export default FiltersWrapper;
